import React from 'react';
import { hydrate, render } from 'react-dom';
import App from './App';
import { BrowserRouter } from 'react-router-dom';

const rootElement = document.getElementById('root');

// Define the app content with BrowserRouter
const AppWithRouter = (
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// Use hydrate for pre-rendered content (react-snap), otherwise use render
if (rootElement.hasChildNodes()) {
  hydrate(AppWithRouter, rootElement);
} else {
  render(AppWithRouter, rootElement);
}

// Add this for react-snap
if (module.hot) {
  module.hot.accept();
}
